import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ initialMinutes = 2, initialSeconds = 0, timerExpired }) => {
  const [minutes, setMinutes] = useState(initialMinutes);
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else if (minutes > 0) {
        setMinutes(minutes - 1);
        setSeconds(59);
      }
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [minutes, seconds]);

    useEffect(() => {
        if (minutes === 0 && seconds === 0) {
            // Timer has reached 00:00, perform an action or notify the user
            console.log('Time is up!');
            if (timerExpired) {
                timerExpired();
            }
        }
  }, [minutes, seconds]);

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : time;
  };

  return (
    <>
        {formatTime(minutes)}:{formatTime(seconds)}
    </>
  );
};

export default CountdownTimer;
